import { render, staticRenderFns } from "./RegionalStatistics.vue?vue&type=template&id=4f52b67e&"
import script from "./RegionalStatistics.vue?vue&type=script&lang=js&"
export * from "./RegionalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RegionalStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports